import { render, staticRenderFns } from "./SlideContentBlock.vue?vue&type=template&id=181557ad&scoped=true&"
import script from "./SlideContentBlock.vue?vue&type=script&lang=js&"
export * from "./SlideContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./SlideContentBlock.vue?vue&type=style&index=0&id=181557ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181557ad",
  null
  
)

export default component.exports